import React from 'react';
import { useIntl } from 'react-intl';
import { Option, Select } from 'carbon-react/lib/components/select';

import styles from '../../prediction-header-bar/prediction-header-bar.scss';
import { useI18nConstants } from '../../../../../report-builder/use-i18n-constants';

interface OutputOnMonthProps {
  disabled?: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  value: string;
}

export const OutputOnMonth = ({ disabled, onChange, value }: OutputOnMonthProps) => {
  const { monthsOfTheYear } = useI18nConstants();
  const intl = useIntl();

  return (
    <div className={styles.formInput}>
      <Select
        autoComplete="off"
        disabled={disabled}
        onChange={onChange}
        value={value}
        label={intl.formatMessage({ id: 'predict.output_on_month', defaultMessage: 'Output on month' })}
        size="large"
      >
        {monthsOfTheYear.map((month, index) => (
          <Option key={month} text={month} value={String(index + 1)} />
        ))}
      </Select>
    </div>
  );
};
